import React from 'react';
import TrainingBack from './BiteUBack';

interface ITrainingNavProps {
  basePath: string;
  curPath: string;
}

const TrainingNav: React.FC<ITrainingNavProps> = (props: ITrainingNavProps) => {
  const { basePath, curPath } = props;
  return (
    <div className='training-nav'>
      <div>
        <TrainingBack />
      </div>
      <div className='training-location'>
        <div className='training-base'>{basePath}</div>
        <div className='training-cur'>{curPath}</div>
      </div>
    </div>
  );
};

export default TrainingNav;
